// @flow

import {InputCommand} from '../../terminal/command';
import type {Command, Param, Commands} from '../commands/resource';
import {StripeSuggestions} from '../autocomplete/stripe';
import {DirectorySuggestions} from '../autocomplete/cdls';

type ParamTuple = [string, Param];
type CommandTuple = [string, Command];

const suggestions = {
  stripe: StripeSuggestions,
  cd: DirectorySuggestions,
  ls: DirectorySuggestions,
};

// Give the user suggestions for input.
export function giveSuggestion(
  inputCommand: InputCommand,
  tree: Commands,
): Array<ParamTuple> | Array<CommandTuple> | Array<[string, {}]> {
  const execs: Array<ParamTuple> = [['stripe', {}]];
  const empty: Array<ParamTuple> = [['', {}]];

  // Don't return any suggestions on parseFailed. This could happen if the user
  // is providing input to a parameter when using single or double quotes
  if (inputCommand.parseFailed) {
    return empty;
  }

  const executable = inputCommand.executable;

  // No executables in put, return all of them.
  if (executable === '') {
    return execs;
  }

  // If the user has not entered any args or flags, get suggestions for
  // executables. See if the input matches any known executables listed above
  if (
    inputCommand.structuredArgs.length === 0 &&
    inputCommand.structuredFlags.length === 0 &&
    // user has entered a space so they're "done" writing in the executable
    !inputCommand.raw.endsWith(' ') &&
    !inputCommand.parseFailed
  ) {
    const execMatches: Array<ParamTuple> = [];
    for (const exec in suggestions) {
      if (exec.startsWith(executable)) {
        execMatches.push([exec, {}]);
      }
    }

    if (execMatches.length === 0) {
      return empty;
    }

    return execMatches;
  }

  if (executable in suggestions) {
    const suggest = new suggestions[executable]();
    return suggest.run(inputCommand, tree);
  }

  return empty;
}
